
import { SvgIcon, SvgIconProps } from "designSystem/index";
import React, { FunctionComponent } from "react";

const Axis3DIcon: FunctionComponent<SvgIconProps> = ({ ...props }) => {
	return (
		<SvgIcon {...props}>
			<svg
				height="24"
				width="24"
				xmlns="http://www.w3.org/2000/svg"
			><g fill="none" fillRule="evenodd"><path d="M0 0h24v24H0z" /><path d="M12.715 14L24 19.907 23.285 22 12 16.093z" fill="#E75E4F" /><path d="M11.11 2l2.19.016L13.19 16 11 15.984z" fill="#71D18F" /><path d="M10.883 14L12 15.862 1.117 22 0 20.138z" fill="#3C94F0" /></g></svg>
		</SvgIcon>
	);
};

export default Axis3DIcon;